import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { motionAllowed } from "./motionEnv";

/** Cycles through words in place; the first word is what crawlers read. */
export default function RotatingWords({ words, interval = 2200, className = "" }) {
  const [i, setI] = useState(0);
  const animate = motionAllowed();
  useEffect(() => {
    if (!animate || words.length < 2) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % words.length), interval);
    return () => clearInterval(t);
  }, [animate, words.length, interval]);
  if (!animate) return <span className={className}>{words[0]}</span>;
  return (
    <span className={`relative inline-grid ${className}`} aria-live="off">
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={words[i]}
          initial={{ y: "0.6em", opacity: 0, filter: "blur(6px)" }}
          animate={{ y: 0, opacity: 1, filter: "blur(0px)" }}
          exit={{ y: "-0.6em", opacity: 0, filter: "blur(6px)" }}
          transition={{ duration: 0.35, ease: [0.22, 0.61, 0.36, 1] }}
          style={{ gridArea: "1 / 1" }}
        >
          {words[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
